/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { AaiMessageTrait } from '../../models/AaiMessageTrait';
import { Node } from '../../../core/models/Node';

/**
 * @author Jakub Senko <jsenko@redhat.com>
 * @param {Node} parent
 * @param {string} name
 * @class
 * @extends AaiMessageTrait
 */
export class Aai20MessageTrait extends AaiMessageTrait {
    public constructor(parent? : any, name? : any) {
        if(((parent != null && parent instanceof <any>Node) || parent === null) && ((typeof name === 'string') || name === null)) {
            let __args = arguments;
            super(parent, name);
        } else if(((typeof parent === 'string') || parent === null) && name === undefined) {
            let __args = arguments;
            let name : any = __args[0];
            super(name);
        } else if(((parent != null && parent instanceof <any>Node) || parent === null) && name === undefined) {
            let __args = arguments;
            super(parent);
        } else throw new Error('invalid overload');
    }
}
Aai20MessageTrait["__class"] = "io.apicurio.datamodels.asyncapi.v2.models.Aai20MessageTrait";
Aai20MessageTrait["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable","io.apicurio.datamodels.core.models.IReferenceNode","io.apicurio.datamodels.asyncapi.models.IAaiTrait","io.apicurio.datamodels.core.models.common.INamed"];




